import React from 'react';
import { FileTextIcon, LayersIcon, CalendarRangeIcon, WrenchIcon } from 'lucide-react';
const stats = [{
  Icon: FileTextIcon,
  value: '300+',
  label: 'Pages'
}, {
  Icon: LayersIcon,
  value: '6',
  label: 'Volumes, one per phase'
}, {
  Icon: CalendarRangeIcon,
  value: '12',
  label: 'Months mapped'
}, {
  Icon: WrenchIcon,
  value: '40+',
  label: 'Templates, scripts & trackers'
}];
const coverage = ['Budget & guest list', 'Vendors', 'Dress, stationery, menu & music', 'RSVPs & seating', 'The final month', 'The day itself'];
export function ProductReveal() {
  return <section aria-labelledby="reveal-heading" className="w-full bg-white" data-id="element-180" data-mp="2n2xg69trtq7t">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20 text-center" data-id="element-181" data-mp="2n50f5jcwitoo">
        <p className="text-[13px] font-semibold uppercase tracking-kicker text-sage-deep" data-id="element-182" data-mp="2ib604t88r2vx">
          The complete planning system for couples without a planner
        </p>

        <h2 id="reveal-heading" className="mt-4 font-serif font-normal text-ink text-[30px] sm:text-[42px] leading-tight" data-id="element-183" data-mp="1pmqidyxq66gw">
          The 12-Month Wedding Plan™
        </h2>
        <p className="mt-3 font-serif italic text-ink-soft text-[20px] sm:text-[23px]" data-id="element-184" data-mp="1f183r1la460t">
          6 Volumes + 5 Bonuses — one volume per phase, from &ldquo;yes&rdquo; to
          &ldquo;I do.&rdquo;
        </p>
        <div className="mx-auto mt-6 h-px w-32 bg-sage/40" aria-hidden="true" data-id="element-185" data-mp="1orueahe526cn" />

        <p className="mx-auto mt-8 max-w-2xl text-[17px] sm:text-[18px] leading-[1.6] text-ink-soft" data-id="element-186" data-mp="s34u2kf1h1ni">
          This is not a checklist. Not a binder organized by topic. Not another
          Pinterest board. It&apos;s the entire year — sequenced. 300+ pages of
          real numbers, booking orders, scripts and templates, split so you never
          read more than the volume of the month you&apos;re living.
        </p>

        <dl className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-9 text-left" data-id="element-187" data-mp="2choossazjitq">
          {stats.map(({
          Icon,
          value,
          label
        }) => <div key={label} data-id="element-188" data-mp="1rsm46mf44sa7">
              <Icon className="w-4 h-4 text-sage" aria-hidden="true" data-id="element-189" data-mp="1rruf7ug0tssw" />
              <dt className="mt-3 font-serif font-normal text-ink text-[34px] leading-none" data-id="element-190" data-mp="1muatk9gzudqx">
                {value}
              </dt>
              <dd className="mt-1.5 text-[14px] text-ink-soft" data-id="element-191" data-mp="21pqoshtb8fow">{label}</dd>
            </div>)}
        </dl>

        <ul className="mt-12 flex flex-wrap justify-center gap-2.5" data-id="element-192" data-mp="1wsqj480dheyb">
          {coverage.map(chip => <li key={chip} className="rounded border border-sage/20 bg-sand px-3.5 py-1.5 text-[14px] font-medium text-ink-soft" data-id="element-193" data-mp="190a466bxm338">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}